module.exports = __webpack_public_path__ + "static/13-match-april1995-2a1803c4c677378821efeaf7b23440dc.jpg";